import AccuracySection from "@/Components/Riskintel/AccuracySection";
import FaqSection, { FAQS } from "@/Components/Riskintel/FaqSection";
import ProductSeo from "@/Components/seo/ProductSeo";
import { PRODUCTS } from "@/lib/products";
import FeaturesSection from "@/Components/Riskintel/FeaturesSection";
import Hero from "@/Components/Riskintel/Hero";
import IndustriesSection from "@/Components/Riskintel/IndustriesSection";
import ProblemsSection from "@/Components/Riskintel/ProblemsSection";
import TrustSection from "@/Components/Riskintel/TrustSection";
import WorkflowSection from "@/Components/Riskintel/WorkflowSection";
import ContactPage from "@/Components/contactPage";

import Head from "next/head";


export default function RiskIntel() {
    return (
        <>
            <ProductSeo product={PRODUCTS.riskIntel} faqs={FAQS} />
            <Head>
                {/* Title and description come from lib/products.js via ProductSeo above */}
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link
                    href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap"
                    rel="stylesheet"
                />
                {/* Page-scoped styles (.riskintel-page). Loaded here instead of
                    globally in _app so other pages don't pay for ~30 kB of CSS. */}
                <link rel="stylesheet" href="/styles/riskintel.css" />
            </Head>
            <div className="riskintel-page">
                <Hero />
                <ProblemsSection />
                <IndustriesSection />
                <FeaturesSection />
                <AccuracySection />
                <WorkflowSection />
                <TrustSection />
                <FaqSection />
            </div>
            <ContactPage />
        </>
    )
}
